// Components
import { FormField } from "@benchmark/ui/components/atomic";
import { FormSection } from "@benchmark/ui/components/atomic";
import { TrimmedTextInput as TextInput } from "@benchmark/ui/components/atomic";
import { PhoneNumbersEditor } from "./PhoneNumbersEditor";

// Types
import type { UseFormReturnType } from "@mantine/form";
import type { PatientFormData, PhoneNumberEntry } from "@benchmark/core/types";

/**
 * Props for TelecomSection component.
 * @agentic @benchmark/core
 */
type TelecomSectionProps = {
  form: UseFormReturnType<PatientFormData>;
};

/**
 * Form section for phone numbers and email (FHIR telecom).
 * @agentic @benchmark/core
 */
export const TelecomSection = ({ form }: TelecomSectionProps) => {
  return (
    <FormSection title="Contact Information">
      <FormField
        label="Phone Numbers"
        required
        description="Add one or more phone numbers. Lower rank = higher priority."
      >
        <PhoneNumbersEditor
          value={(form.values.phoneNumbers as PhoneNumberEntry[]) || []}
          onChange={(value) => form.setFieldValue("phoneNumbers", value)}
          error={form.errors.phoneNumbers as string}
          required={true}
        />
      </FormField>

      <FormField label="Email">
        <TextInput
          type="email"
          placeholder="Enter email address"
          autoComplete="off"
          {...form.getInputProps("email")}
        />
      </FormField>
    </FormSection>
  );
};
